import React from "react";
import styled from "styled-components";
import { FaDownload, FaUpRightFromSquare } from "react-icons/fa6";
import { colors } from "../theme";
import AppIcon from "../AppIcon";
import { PillButton } from "./shared";

const RESUME_URL = "/assets/Harrison Qu Resume.pdf";

const downloadResume = () => {
  const link = document.createElement("a");
  link.href = encodeURI(RESUME_URL);
  link.download = "Harrison Qu Resume.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${colors.window};
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 2px solid ${colors.ink};
  background: ${colors.windowHeader};
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 14px;
  margin-right: auto;
`;

const Frame = styled.iframe`
  flex: 1;
  width: 100%;
  border: none;
`;

const ResumeApp = () => (
  <Wrap>
    <Toolbar>
      <Title>Harrison Qu - Resume.pdf</Title>
      <PillButton
        $bg={colors.sky}
        onClick={() => window.open(encodeURI(RESUME_URL), "_blank")}
      >
        <AppIcon icon={FaUpRightFromSquare} size={14} /> Open
      </PillButton>
      <PillButton $bg={colors.green} onClick={downloadResume}>
        <AppIcon icon={FaDownload} size={14} /> Download
      </PillButton>
    </Toolbar>
    <Frame title="Harrison Qu Resume" src={`${encodeURI(RESUME_URL)}#view=FitH`} />
  </Wrap>
);

export default ResumeApp;
